//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import SlSellerSaleCommissionList from '@/views/Sale/SlSellerSaleCommission/SlSellerSaleCommissionList'

//
export default {
  path: 'seller_sale_commissions',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'sl-seller-sale-commission',
      component: SlSellerSaleCommissionList,
    },
  ],
  meta: {
    title: 'Reporte de comisión de vendedores',
  }
}